import { DEAL_STATUSES } from "@loanbossinc/component-library";
import moment from "moment";

export const filterDeadDeals = (items, searchText) => getDealsByStatus(DEAL_STATUSES.DEAD, items, searchText);
export const filterSoldDeals = (items, searchText) => getDealsByStatus(DEAL_STATUSES.SOLD, items, searchText);
export const filterClosedDeals = (items, searchText) => {
  const closedDeals = getDealsByStatus(DEAL_STATUSES.CLOSED, items, searchText);
  const modifyDeals = getDealsByStatus(DEAL_STATUSES.MODIFYING, items, searchText);
  const refiDeals = getDealsByStatus(DEAL_STATUSES.REFINANCE, items, searchText);
  const suppDeals = getDealsByStatus(DEAL_STATUSES.ADDING_SUPPLEMENTAL, items, searchText);

  return [
    ...closedDeals,
    ...modifyDeals,
    ...refiDeals,
    ...suppDeals
  ];
};
const getDealsByStatus = (status, items, searchText) => {
  items = getFilteredListByParameter(items, searchText, "name");
  if (!items || !status) {
    return [];
  }

  return items.reduce((accum, curr) => {
    if (curr && curr.dealStatusId === status) {
      accum.push(curr);
    }

    return accum;
  }, []);
};

export const filterByParameter = (items, searchText, parameter) => getFilteredListByParameter(items, searchText, parameter);
const getFilteredListByParameter = (items, searchText, parameter) => {
  if (!items) {
    return [];
  }
  if (!searchText || searchText.trim() === "" || !parameter) {
    return items;
  }

  return items.reduce((accum, item) => {
    if (item[parameter] && item[parameter].toLowerCase().includes(searchText.toLowerCase())) {
      accum.push(item);
    }

    return accum;
  }, []);
};

export const filterByStage = (items, stageId) => {
  if (!items) {
    return [];
  }

  return items.reduce((accum, item) => {
    if (item && item.stageId === stageId) {
      accum.push(item);
    }

    return accum;
  }, []);
};

export const filterDealNamesByFund = (items, groupId) => {
  if (!items) {
    return [];
  }

  return items.reduce((accum, item) => {
    const hasFunds = item && item.funds && item.funds.length;
    if (!hasFunds) {
      return accum;
    }

    const hasFund = item.funds.some(fund => fund.id === groupId);
    if (hasFund) {
      accum.push(item);
    }

    return accum;
  }, []);
};

export const filterDealNamesBySponsorCompany = (items, sponsorCompanyId) => {
  if (!items) {
    return [];
  }

  return items.reduce((accum, item) => {
    const hasSponsor = item.sponsorCompanyId === sponsorCompanyId;
    if (hasSponsor) {
      accum.push(item);
    }

    return accum;
  }, []);
};
export const filterOutByStatus = (items, dealStatuses) => {
  if (!items) {
    return [];
  }
  if (!dealStatuses || !dealStatuses.length) {
    return items;
  }

  return items.reduce((accum, item) => {
    if (item && !dealStatuses.some(status => status === item.dealStatusId)) {
      accum.push(item);
    }

    return accum;
  }, []);
};

export const sortByDateProp = (items, property) => {
  if (!items || !items.length) {
    return;
  }

  return items.sort((a, b) => {
    if (a[property] && !b[property]) {
      return -1;
    }
    if (!a[property] && b[property]) {
      return 1;
    }

    return moment(a[property]).isBefore(b[property]) ? -1 : 1;
  });
};

export const filterDealNamesByCompany = (items, companyId) => {
  if (!items) {
    return [];
  }

  return items.reduce((accum, item) => {
    const hasFunds = item && item.funds && item.funds.length;
    if (!hasFunds) {
      return accum;
    }

    const hasFund = item.funds.some(fund => fund.companyId === companyId);
    if (hasFund) {
      accum.push(item);
    }

    return accum;
  }, []);
};
